import { useFavoriteGameStore } from "@stores/favorite-games"
import { useAuthStore } from "@stores/auth";

interface Game {
    id: number;
    name: string;
    image: string;
    rating: number;
    releaseDate: string;
    platforms: string;
    genres: string;
    description: string;
}

export default function useFavorite() {
    const favoriteGameStore = useFavoriteGameStore();
    const authStore = useAuthStore();

    let favorites = ref([]);
    
    const loadFavorites = async () => {
        favorites.value = favoriteGameStore.favorites;
    };

    const addFavorite = async (game: Game) => {

        if (authStore.user?.id && authStore.isLoggedIn) {
            await favoriteGameStore.addFavorite(game)
                .then(() => {
                })
                .finally(() => {
                    loadFavorites();
                });

        } else {
            authStore.modalOpen('login')
            return;
        }  
    }

    const removeFavorite = async (game: Game) => {
        await favoriteGameStore.removeFavorite(game)
            .then(() => {
            })
            .finally(() => {
                loadFavorites();
            });
    }

    const clearFavorites = async () => {
        await favoriteGameStore.clearFavorites()
            .then(() => {
            })
            .finally(() => {
                loadFavorites();
            });
    }

    const isFavorite = (gameId: number) => {
        return favoriteGameStore.favorites.some(favorite => favorite.id === gameId);
    }
    
    return {
        favorites,
        loadFavorites,
        addFavorite,
        removeFavorite,
        isFavorite,
        clearFavorites,
    };
};